import { EnumSortDirectionName, ISortDirectionType } from "src/types/common";
import { EnumSearchQueryParams } from "../search.types";

export const mapSortDirectionToQuery = (sortDirection: ISortDirectionType) => {
    return sortDirection !== null
        ? `${EnumSearchQueryParams.SortDirection}=${sortDirection === 1 ? EnumSortDirectionName.Descending : EnumSortDirectionName.Ascending}`
        : "";
};
